import styled from 'styled-components';
import { cardShadow } from '../../../../themes/shadows';

export const HiddenThumb = styled.div`
  display: none;
`;

export const Container = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  padding: 5px;
  width: 100%;
  background: ${(props) => props.theme.colors.card};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  box-shadow: ${cardShadow};
  height: ${(props) => (props.open ? '500px' : '60px')};
  border-radius: 10px;
  transition: 0.2s all;
  z-index: 1;

  #notification-box {
    display: flex;
    align-items: center;
    width: 100%;
  }

  #notification-box-second {
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    height: 100%;

    @media (max-width: ${(props) => props.theme.breakpoints.laptop}) {
      height: ${(props) => props.open && '100%'};
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.laptop}) {
    position: relative;
    width: 100%;
    height: ${(props) => (props.open ? '500px' : '95%')};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    ${(props) => props.open && 'display: flex; align-items: start'}
  }
`;

export const TotalWrapper = styled.div`
  display: flex;
  margin-right: 10px;
  align-self: flex-start;

  #total {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 65px;
    height: 60px;
    background: ${(props) => props.theme.colors.blue};
    color: ${(props) => props.theme.colors.white};
    font-size: 16px;
    border-radius: 10px;
    font-weight: bold;
  }

  #status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 10px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => props.open && 'column'};
  justify-content: space-between;
  margin: ${(props) => (props.open ? '0 auto' : '0 10px')};

  #option {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    width: 90px;
    height: 20px;
    background: ${(props) => props.theme.colors.lightgrey};
    color: ${(props) => props.theme.colors.darkerblue};
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 10px;
    transition: all 0.2s;
    margin: ${(props) => (props.open ? '10px 0' : '0 10px')};
    cursor: pointer;

    :hover {
      background: ${(props) => props.theme.colors.darkblue};
      color: ${(props) => props.theme.colors.white};
    }

    @media (max-width: ${(props) => props.theme.breakpoints.laptop}) {
      margin: ${(props) => (props.open ? '20px 20px 0 10px' : '0 10px')};
    }
  }
`;

export const Notification = styled.div`
  display: flex;
  padding: 10px;
  margin: 0 auto;
  ${(props) => props.clickable && 'cursor: pointer'};

  #status {
    color: ${(props) => props.theme.colors.darkblue};
    font-weight: bold;
    text-transform: uppercase;
  }

  #data {
    color: ${(props) => props.theme.colors.label};
    font-weight: bold;
  }

  #description {
    color: ${(props) => props.theme.colors.darkerblue};
    font-weight: bold;
  }

  > * {
    font-size: 12px;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 20px 0 0 0;
`;

export const Button = styled.div`
  border: 1px solid
    ${(props) =>
      props.open ? props.theme.colors.red : props.theme.colors.lightblue};
  border-radius: 10px;
  padding: ${(props) => (props.config ? '5px 30px' : '5px 10px')};
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  transition: all 270ms;
  background: transparent;
  color: ${(props) =>
    props.open ? props.theme.colors.red : props.theme.colors.lightblue};
  align-self: flex-start;

  :hover {
    background: ${(props) =>
      props.open ? props.theme.colors.red : props.theme.colors.lightblue};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const Label = styled.label`
  font-size: ${(props) => (props.size ? props.size : '16px')};
  color: ${(props) => props.color};
  ${(props) => props.margin && `margin: ${props.margin}`};

  ${(props) => props.bold && 'font-weight: bold'};
`;

export const OverLabel = styled.div`
  position: absolute;
  left: inherit;
  z-index: 2;
  margin: ${(props) => (props.on ? '3px 3px 0 26px' : '3px 3px 0 28px')};
  font-weight: bold;
  color: ${(props) => !props.on && props.theme.colors.label};
  cursor: pointer;

  ${(props) =>
    props.on &&
    `font-size: 16px; background: ${props.theme.colors.blue}; -webkit-background-clip: text; -webkit-text-fill-color: transparent;`};
`;

export const ThumbVertical = styled.div`
  background: ${(props) => props.theme.colors.green};
  width: 10px;
  border-radius: 10px;
  ${(props) => props.opaque && 'opacity: 0.3'}
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.card};
  border-radius: 10px;
  padding: 20px 20px 20px 55px;
  height: calc(100% - 40px);

  #header {
    margin: 0 10px 0 auto;

    #close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background: ${(props) => props.theme.colors.disabled};
      cursor: pointer;
      transition: 0.2s all;

      color: ${(props) => props.theme.colors.label};
      font-size: 11px;

      :hover {
        transform: scale(1.25);
      }
    }
  }

  #title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 60px 0 10px;
    text-transform: uppercase;
  }
`;

export const NotificationItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: start;
  width: calc(100%-100px);
  padding: 5px 20px 0 20px;
  margin: 0 20px;
  font-weight: bold;

  :first-child {
    padding: 0 20px;
  }

  :last-child {
    padding: 0 20px 20px 20px;
    #line {
      display: none;
    }
  }

  #divisor {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 10px 0 0;
  }

  #data {
    color: ${(props) => props.theme.colors.label};
  }

  #description {
    color: ${(props) => props.theme.colors.darkerblue};
  }
`;

export const Line = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PathCircle = styled.div`
  width: 8px;
  height: 8px;
  background: ${(props) => props.theme.colors.disabled};
  margin: 2px;
  border-radius: 50%;
`;

export const PathLine = styled.div`
  width: 2px;
  height: 50px;
  background: ${(props) => props.theme.colors.disabled};
`;

export const TimeoutContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  gap: 12px;
  color: ${(props) => props.theme.colors.label};
`;

export const TimeoutTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  color: ${(props) => props.theme.colors.darkerblue};
`;

export const TimeoutMessage = styled.p`
  margin: 0;
  font-size: 13px;
  max-width: 320px;
  line-height: 1.4;
`;

export const RetryButton = styled.button`
  margin-top: 4px;
  padding: 6px 16px;
  border: 1px solid ${(props) => props.theme.colors.lightblue};
  border-radius: 10px;
  background: transparent;
  color: ${(props) => props.theme.colors.lightblue};
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
  transition: all 200ms;

  :hover {
    background: ${(props) => props.theme.colors.lightblue};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const ModalConfigContainer = styled(ModalContainer)`
  #option {
    display: flex;
    justify-content: space-between;
    margin: 20px;
    padding: 5px;

    :first-child {
      margin: 40px 20px 20px 20px;
    }
  }

  .react-switch-bg {
    box-shadow: inset 0 0 3px #000000;
  }
`;

export const getModalStyles = (colors) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 102,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    width: '75%',
    height: '80%',
    backgroundColor: colors.card,
    borderColor: colors.disabled,
  },
});

export const getModalStylesConfig = (colors) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 102,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    width: '55%',
    height: '80%',
    backgroundColor: colors.card,
    borderColor: colors.disabled,
  },
});
